import vuetify from '../plugins/vuetify'

const requiredRule = [
    v => !!v || vuetify.framework.lang.t('$vuetify.rules.required')    
];

const emailRule = [
    v => /.+@.+\..+/.test(v) || vuetify.framework.lang.t('$vuetify.rules.email')    
]

const nameRule = [    
    v => (v && v.length <= 100) || vuetify.framework.lang.t('$vuetify.rules.name')
]

const numberRule = [ 
    v => (v &&  !isNaN(parseFloat(String(v).replace(',', '.')))  && parseFloat(String(v).replace(',', '.')) >= 0) || vuetify.framework.lang.t('$vuetify.rules.number')    
]

const percentRule = [ 
    v => (v &&  !isNaN(parseFloat(v.replace(',', '.')))  && parseFloat(v.replace(',', '.')) > 0 && parseFloat(v.replace(',', '.')) <= 100) || 'Insira um percentual entre 0 e 100'   
]

export default {
    computed: {        
        requiredRule() { return requiredRule },
        emailRule() { return emailRule },
        nameRule() { return nameRule },
        numberRule() { return numberRule },
        percentRule() {return percentRule}
    }
}